<template>
  <div class="ion-margin-top report-component">
    <!-- START Number item -->
    <ion-item button :disabled="disabled" @click.stop="openSinglePicker">
      <ion-label v-if="placeholders && placeholders[0]" position="floating">
        {{ placeholders[0] }}
      </ion-label>
      <ion-label v-else position="floating">Saisir...</ion-label>

      <ion-input
        :disabled="disabled"
        :value="format(date)"
        readonly
        tabindex="-1"
        class="no-pointer-events"
      ></ion-input>
    </ion-item>
  </div>
</template>

<script>
import { IonItem, IonInput, IonLabel, pickerController } from '@ionic/vue';
import {
  stringToFloat,
  floatToString,
  generateFiveMinuteIntervals,
} from '@/services/utils/dateUtils';
import utils from '@/services/utils/Utils';

const POSSIBLE_MINUTES = generateFiveMinuteIntervals();

export default {
  name: 'Number',

  components: {
    IonItem,
    IonLabel,
    IonInput,
  },

  props: {
    title: String,
    placeholders: Array,
    date: String,
    disabled: Boolean,
  },

  emits: ['update:date'],

  methods: {
    format(date) {
      if (!date) return '';

      const exploded = date.toString().split('T');
      if (exploded && exploded[1]) return exploded[1];

      return floatToString(date);
    },

    async openSinglePicker() {
      let selectedDates = [0, 0];

      if (this.date) {
        // if already set date, re-use it
        const date = floatToString(this.date).split(':');
        selectedDates = [date[0], date[1]];
      }

      const picker = await pickerController.create({
        columns: utils.generatePickerColumns(
          selectedDates[0],
          selectedDates[1],
          POSSIBLE_MINUTES,
        ),
        buttons: [
          {
            text: 'Supprimer',
            handler: () => {
              this.$emit(`update:date`, null);
            },
          },
          {
            text: 'Valider',
            handler: time => {
              this.$emit(
                'update:date',
                stringToFloat(
                  `${time.hours.value}:${time.minutes.value}`,
                ).toFixed(2),
              );
            },
          },
        ],
      });

      await picker.present();
    },
  },
};
</script>
